export const LSK_CART = 'LC__cart_products'
